import Relay from 'react-relay';

export const borrowerFieldFragment = {
  name: Relay.QL`fragment on Borrower { name }`,
  address: Relay.QL`fragment on Borrower { address }`,
  city: Relay.QL`fragment on Borrower { city }`,
  state: Relay.QL`fragment on Borrower { state }`,
  zip: Relay.QL`fragment on Borrower { zip }`,
  county: Relay.QL`fragment on Borrower { county }`,
  unit: Relay.QL`fragment on Borrower { unit }`,
  employment: Relay.QL`fragment on Borrower { employment }`,
  employmentLength: Relay.QL`fragment on Borrower { employmentLength }`,
  salary: Relay.QL`fragment on Borrower { salary }`,
  hourly: Relay.QL`fragment on Borrower { hourly }`,
  incomeDeclined: Relay.QL`fragment on Borrower { incomeDeclined }`,
  bonus: Relay.QL`fragment on Borrower { bonus }`,
  commission: Relay.QL`fragment on Borrower { commission }`,
  twoYearsAtCurrentJob: Relay.QL`fragment on Borrower { twoYearsAtCurrentJob }`,
  continuityInRole: Relay.QL`fragment on Borrower { continuityInRole }`,
  lastYearBonus: Relay.QL`fragment on Borrower { lastYearBonus }`,
  twoYearOldBonus: Relay.QL`fragment on Borrower { twoYearOldBonus }`,
  lastYearCommission: Relay.QL`fragment on Borrower { lastYearCommission }`,
  twoYearOldCommission: Relay.QL`fragment on Borrower { twoYearOldCommission }`,
  cohabitate: Relay.QL`fragment on Borrower { cohabitate }`,
  ownsPrimaryResidence: Relay.QL`fragment on Borrower { ownsPrimaryResidence }`,
  residenceSoldPrior: Relay.QL`fragment on Borrower { residenceSoldPrior }`,
  email: Relay.QL`fragment on Borrower { email }`,
  approximateCreditScore: Relay.QL`fragment on Borrower { approximateCreditScore }`,
  firstTimeBuyer: Relay.QL`fragment on Borrower { firstTimeBuyer }`,
  dateOfBirth: Relay.QL`fragment on Borrower { dateOfBirth }`,
  vaQualification: Relay.QL`fragment on Borrower { vaQualification }`,
  hubspotToken: Relay.QL`fragment on Borrower { hubspotToken }`
};

export class BorrowerMutation extends Relay.Mutation {
  static fragments = {
    borrower: () => Relay.QL`
      fragment on Borrower {
        id
      }
    `
  };
  getMutation() {
    return Relay.QL`mutation{setBorrowerFields}`;
  }
  getConfigs() {
    return [
      {
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          borrower: this.props.borrower.id
        }
      }
    ];
  }
  getFatQuery() {
    return Relay.QL`
       fragment on SetBorrowerFieldsPayload {
         borrower {
           ${this.props.fields
             .keySeq()
             .map((key) => borrowerFieldFragment[key])
             .toArray()}
         }
       }
    `;
  }
  getVariables() {
    return this.props.fields.set('id', this.props.borrower.id).toJS();
  }
  getOptimisticResponse() {
    return {
      borrower: this.props.fields.set('id', this.props.borrower.id).toJS()
    };
  }
}

export const loanFieldFragment = {
  termsAgree: Relay.QL`fragment on Loan { termsAgree }`,
  scenario: Relay.QL`fragment on Loan { scenario }`,
  hasCoborrower: Relay.QL`fragment on Loan { hasCoborrower }`,
  propertyType: Relay.QL`fragment on Loan { propertyType }`,
  occupancy: Relay.QL`fragment on Loan { occupancy }`,
  fixed30: Relay.QL`fragment on Loan { fixed30 }`,
  fixed20: Relay.QL`fragment on Loan { fixed20 }`,
  fixed15: Relay.QL`fragment on Loan { fixed15 }`,
  fixed10: Relay.QL`fragment on Loan { fixed10 }`,
  arm5: Relay.QL`fragment on Loan { arm5 }`,
  arm7: Relay.QL`fragment on Loan { arm7 }`,
  arm10: Relay.QL`fragment on Loan { arm10 }`,
  otherProperty: Relay.QL`fragment on Loan { otherProperty }`,
  taxesFiled: Relay.QL`fragment on Loan { taxesFiled }`,
  ownsCompany: Relay.QL`fragment on Loan { ownsCompany }`,
  paysAlimony: Relay.QL`fragment on Loan { paysAlimony }`,
  alimonyPayment: Relay.QL`fragment on Loan { alimonyPayment }`,
  refiPurpose: Relay.QL`fragment on Loan { refiPurpose }`,
  refiCurrentProduct: Relay.QL`fragment on Loan { refiCurrentProduct }`,
  refiCurrentRate: Relay.QL`fragment on Loan { refiCurrentRate }`,
  refiLiens: Relay.QL`fragment on Loan { refiLiens }`,
  isGovernmentLoan: Relay.QL`fragment on Loan { isGovernmentLoan }`,
  purchasePrice: Relay.QL`fragment on Loan { purchasePrice }`,
  downPayment: Relay.QL`fragment on Loan { downPayment }`,
  downPaymentGift: Relay.QL`fragment on Loan { downPaymentGift }`,
  creditAgree: Relay.QL`fragment on Loan { creditAgree }`,
  preapprovalState: Relay.QL`fragment on Loan { preapprovalState }`,
  cashOutValue: Relay.QL`fragment on Loan { cashOutValue }`,
  citizen: Relay.QL`fragment on Loan { citizen }`,
  visa: Relay.QL`fragment on Loan { visa }`,
  visaValid: Relay.QL`fragment on Loan { visaValid }`,
  condoFee: Relay.QL`fragment on Loan { condoFee }`,
  lawsuit: Relay.QL`fragment on Loan { lawsuit }`,
  previousPreapproval: Relay.QL`fragment on Loan { previousPreapproval }`,
  acceptedOffer: Relay.QL`fragment on Loan { acceptedOffer }`,
  loanAddress: Relay.QL`fragment on Loan { loanAddress }`,
  loanUnit: Relay.QL`fragment on Loan { loanUnit }`,
  loanCity: Relay.QL`fragment on Loan { loanCity }`,
  loanCounty: Relay.QL`fragment on Loan { loanCounty }`,
  loanState: Relay.QL`fragment on Loan { loanState }`,
  loanZip: Relay.QL`fragment on Loan { loanZip }`,
  closeDate: Relay.QL`fragment on Loan { closeDate }`,
  isNewConstruction: Relay.QL`fragment on Loan { isNewConstruction }`,
  qualifyStart: Relay.QL`fragment on Loan { qualifyStart }`,
  hasAgent: Relay.QL`fragment on Loan { hasAgent }`,
  otherOffer: Relay.QL`fragment on Loan { otherOffer }`,
  otherOfferProduct: Relay.QL`fragment on Loan { otherOfferProduct }`,
  otherOfferRate: Relay.QL`fragment on Loan { otherOfferRate }`,
  advisor: Relay.QL`fragment on Loan { advisor }`,
  purchaseTimeFrame: Relay.QL`fragment on Loan { purchaseTimeFrame }`,
  lastFinancingExperience: Relay.QL`fragment on Loan { lastFinancingExperience }`,
  pitch: Relay.QL`fragment on Loan { pitch }`
};

export class LoanMutation extends Relay.Mutation {
  static fragments = {
    loan: () => Relay.QL`
      fragment on Loan {
        id
      }
    `
  };
  getMutation() {
    return Relay.QL`mutation{setLoanFields}`;
  }
  getConfigs() {
    return [
      {
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          loan: this.props.loan.id
        }
      }
    ];
  }
  getFatQuery() {
    return Relay.QL`
       fragment on SetLoanFieldsPayload {
         loan {
           ${this.props.fields
             .keySeq()
             .map((key) => loanFieldFragment[key])
             .toArray()}
         }
       }
    `;
  }
  getVariables() {
    return this.props.fields.set('id', this.props.loan.id).toJS();
  }
  getOptimisticResponse() {
    return {
      loan: this.props.fields.set('id', this.props.loan.id).toJS()
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/app/mutations.js